import useLocale from "hooks/useLocale";
import { DefaultMDXProvider } from "../components/default-mdx-provider";
import * as FocusArticlesAr from "../content/ar/focus-articles.mdx";
import * as FocusArticlesDe from "../content/de/focus-articles.mdx";
import * as FocusArticlesEn from "../content/en/focus-articles.mdx";
import * as FocusArticlesEs from "../content/es/focus-articles.mdx";
import * as FocusArticlesFr from "../content/fr/focus-articles.mdx";
import * as FocusArticlesRu from "../content/ru/focus-articles.mdx";
import * as FocusArticlesZh from "../content/zh/focus-articles.mdx";

const localeContents = {
  ar: FocusArticlesAr,
  de: FocusArticlesDe,
  en: FocusArticlesEn,
  es: FocusArticlesEs,
  fr: FocusArticlesFr,
  ru: FocusArticlesRu,
  zh: FocusArticlesZh,
} as const;

export default function FocusArticles() {
  const locale = useLocale();
  const { default: Content, frontmatter } = localeContents[locale];

  return (
    <DefaultMDXProvider frontmatter={frontmatter}>
      <Content />
    </DefaultMDXProvider>
  );
}
